var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',[_c('el-input',{attrs:{"type":"textarea","rows":10,"placeholder":"请输入意见"},model:{value:(_vm.contentInput),callback:function ($$v) {_vm.contentInput=$$v},expression:"contentInput"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }